module.exports = __webpack_public_path__ + "img/picto-flexible.80091cdc.svg";